import React from "react";
import { DateRangeChartProps } from "../types";
import { DateRangeChartComponent } from "../components";
import { generateRenewableNonRenewableCategories, generateXAxisData, getEmissionType } from "../utils";

export const RenewableNonRenewableChart = ({
  dateRangeType,
  subTabName,
  currentMainTab,
  ...props
}: DateRangeChartProps) => {
  const generateChartData = (data: any[]) =>
    generateRenewableNonRenewableCategories(data);

  const generateSeriesData = (chartData: any, sortedCategories: string[]) =>
    generateXAxisData(
      chartData,
      sortedCategories,
      dateRangeType,
      getEmissionType(
        subTabName === "location" || subTabName === "market",
        currentMainTab === "Consumption",
        subTabName
      )
    );

  const getSeriesNames = (key: string) => {
    if (key === "renewableConsumption") return "Renewable";
    if (key === "noRenewableConsumption") return "Non-Renewable";
    return key;
  };

  return (
    <DateRangeChartComponent
      {...props}
      dateRangeType={dateRangeType}
      subTabName={subTabName}
      currentMainTab={currentMainTab}
      chartType="renewable-vs-no-renewable"
      dataKey="renewableVsNoRenewable"
      generateChartData={generateChartData}
      generateSeriesData={generateSeriesData}
      getSeriesNames={getSeriesNames}
    />
  );
};
